import { defineMessages, useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { classNames, useAppConfig } from "@ct-react/core";
import { AnyAccommodationFeatures, Location } from "@shared/graphql";
import { article } from "../../i18n/sharable-defs";
import { SkeletonableProps, WithTitle } from "../../tools/components";
import { MapContainer } from "../../bundles/map";
import HomeMarker from "../../bundles/map/home-marker";
import SpriteSvg from "../common/svg";
import "./location.scss";

const transDefs = defineMessages({
  label: { id: "article.map-label", defaultMessage: "Vous pouvez consulter l'emplacement de ce bien ici." }
});

type Props = {
  address: Location;
  coordinates?: [ number, number ];
  features?: AnyAccommodationFeatures;
}
const LocationPart = ({ className, loading, title, data }: WithTitle<SkeletonableProps<Props>>) => {

  const intl = useIntl();
  const { options: { mapToken } } = useAppConfig();

  const wrapperClasses = classNames("location-part", className);

  if (loading || !data)
    return (
      <div className={wrapperClasses}>
        <h2><Skeleton width="33%" /></h2>
        <Skeleton containerClassName="mapped" inline={true}
                  style={{ width: "100%", height: "100%", maxWidth: "unset" }} />
      </div>);

  return (
    <div className={wrapperClasses}>
      <h2>{title}</h2>
      {data.features?.onShoppingArea &&
        <span>
          <SpriteSvg id="cart-shopping"/>
          {intl.formatMessage(article.nearShoppingArea)}
        </span>
      }
      {data.features?.nearSkiArea &&
        <span>
          <SpriteSvg id="telecabin"/>
          {intl.formatMessage(article.nearSkiArea)}
        </span>
      }
      {data.features?.nearBusStop && //#TODO
        <span>
          <SpriteSvg id="bus"/>
          {intl.formatMessage(article.nearBusStation)}
        </span>
      }
      {!!data.coordinates &&
        <MapContainer mapboxToken={mapToken} className="mapped" center={data.coordinates} zoom={15}>
          <HomeMarker position={data.coordinates} />
        </MapContainer>
      }
    </div>);

}

export default LocationPart;
